/**
 * Скролл к каретке ВНУТРИ textarea промпта. Поле имеет max-height + overflow-y:
 * auto (см. .gm__textarea), поэтому при большом промпте оно скроллится внутри.
 * Нужно для анимированной вставки демо-переменной: если место вставки ушло за
 * пределы видимой части поля — плавно подводим его.
 *
 * mirror-div измеряет Y позиции символа `pos` с учётом мягких переносов строк
 * (по одному \n считать нельзя — длинные строки переносятся визуально).
 */

function caretTopInTextarea(ta: HTMLTextAreaElement, pos: number): number {
	const cs = getComputedStyle(ta)
	const padL = parseFloat(cs.paddingLeft) || 0
	const padR = parseFloat(cs.paddingRight) || 0
	const padTop = parseFloat(cs.paddingTop) || 0
	const div = document.createElement('div')
	div.style.position = 'absolute'
	div.style.top = '-9999px'
	div.style.left = '-9999px'
	div.style.visibility = 'hidden'
	div.style.whiteSpace = 'pre-wrap'
	div.style.wordWrap = 'break-word'
	div.style.boxSizing = 'content-box'
	div.style.width = Math.max(0, ta.clientWidth - padL - padR) + 'px'
	div.style.fontFamily = cs.fontFamily
	div.style.fontSize = cs.fontSize
	div.style.fontWeight = cs.fontWeight
	div.style.fontStyle = cs.fontStyle
	div.style.lineHeight = cs.lineHeight
	div.style.letterSpacing = cs.letterSpacing
	div.textContent = ta.value.slice(0, pos)
	const span = document.createElement('span')
	// Непустой контент — иначе offsetTop у пустого span нестабилен.
	span.textContent = ta.value.slice(pos) || '.'
	div.appendChild(span)
	document.body.appendChild(div)
	const top = span.offsetTop
	document.body.removeChild(div)
	return padTop + top
}

/** Подводит символ `pos` к видимой части textarea (внутренний скролл поля). */
export function scrollCaretIntoView(ta: HTMLTextAreaElement, pos: number): void {
	const caretTop = caretTopInTextarea(ta, pos)
	const lh = parseFloat(getComputedStyle(ta).lineHeight) || 20
	const viewH = ta.clientHeight
	if (caretTop < ta.scrollTop + lh) {
		ta.scrollTop = Math.max(0, caretTop - lh)
	} else if (caretTop > ta.scrollTop + viewH - lh) {
		ta.scrollTop = caretTop - viewH + lh * 2
	}
}
